import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ApiResponseCode, LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { authenticateErrorAction, AuthenticationActionTypes } from '../+state';
import { TokenResult } from '../models';
import { BaseHandler } from './base.handler';

export class AccountLockedHandler extends BaseHandler {
  public handle(response: LoyaltyResponse<TokenResult>): TypedAction<AuthenticationActionTypes> {
    if (response.soloResponseCode === ApiResponseCode.Account_Locked) {
      const failure = new AppStateFailureBuilder()
        .setFailureType(FailureType.Validation)
        .addFailure(new AppStateFailureItemWithErrorCode(ApiResponseCode.Account_Locked, ApiResponseCode.Account_Locked))
        .build();
      return authenticateErrorAction({ failure });
    }
    return this.nextHandler.handle(response);
  }
}
